<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
            <el-col :span="12">
            <el-form-item label="报废时间" prop="scrapTime">
              
              <el-date-picker
                disabled
                v-model="form.scrapTime"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                style="width: 100%;"
               >
              </el-date-picker>
                      
            </el-form-item>
          </el-col>
            
            <el-col :span="12">
              <el-form-item label="报废人员" prop="scrapOperateUserName">
                
                <el-input
                disabled
                   v-model="form.scrapOperateUserName"
               placeholder="请输入报废人员"
                  maxlength="20"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
           
            <el-col :span="24">
              <el-form-item label="报废说明" prop="scrapDesc">
                
                <el-input
           
             placeholder="请输入报废说明"
              type="textarea"
              :rows="4"
              disabled
              maxlength="500"
              v-model="form.scrapDesc">
            </el-input>
                        
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
    </div>
  </template>
  <script>
  
  import { getSmartDeviceDetail } from '@/api/nursingHome/elderDevice';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
    
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        provideList: [],
        form: {
          deviceSerial:"",
          code: '',
          name: '',
          reportTime: '',
          repairUserName: '',
          troubleType: '',
          troubleReason: '',
          repairEndTime: '',
          repairAmount: '',
          description: '',
        },
        formRules: {
         
          reportTime:[{ required: true, message: '报修时间不能为空', trigger: 'change' }],
          repairUserName: [{ required: true, message: '维修人员不能为空', trigger: 'blur' }],
        },
        matetialList: [],
        deviceCategoryList: [],
        userList: [],
        deviceTypeIdList: [],
        deviceModelIdList: [],
        
        paymentTypeList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      
       initData() {
        getSmartDeviceDetail({id:this.row.id}).then((res) => {
            this.form = res.data
        })
      },
      saveRecord() {
        this.$refs['formRef'].validate((valid) => {
            if (valid) {
              smartDeviceResumeRepairSave(this.form).then((res) => {
                this.$message.success('新增成功');
                this.$emit('success');
              });
            }
          });
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  